import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Partner} from "../../../shared/interface/partner";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {PartnerService} from "../../../shared/services/partner.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {validIban} from "../../../shared/validator/iban-validator";
import {HttpErrorResponse} from "@angular/common/http";
import {delay, takeUntil} from "rxjs/operators";

export interface ChangeRegionalDialogData {
  partnerObject: Partner;
}
@Component({
  selector: 'app-change-account-number-dialog',
  templateUrl: './change-account-number-dialog.component.html',
  styleUrls: ['./change-account-number-dialog.component.scss']
})
export class ChangeAccountNumberDialogComponent implements OnInit, OnDestroy {

  changeAccountNumberForm: FormGroup;
  partnerObject: Partner;
  processingRequest = false;
  accountNumberControl: FormControl;
  enableSaveButton = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<ChangeAccountNumberDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeRegionalDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private partnerService: PartnerService,
    private snack: MatSnackBar,
  ) {
    this.partnerObject = data.partnerObject;
    this.changeAccountNumberForm = fb.group({
      accountNumber: this.accountNumberControl = fb.control('', [Validators.required, validIban()]),
    });
  }

  ngOnInit(): void {
    this.changeAccountNumberForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.changeAccountNumberForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;

    this.partnerService.changeAccountNumber(this.changeAccountNumberForm.value, this.partnerObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie zaktualizowano obiekt partnera', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas aktualizacji obiektu partnera wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
